import { version as KJ_UPLOADER_VERSION } from '../../../../package.json';
import FilePresenter from './FilePresenter';

class EventPresenter {
  constructor(data = {}) {
    this.update(data);
  }

  update({
    filePresenters: newFilePresenters = [],
    errors: newErrors = [],
  }) {
    this.filePresenters = [...(this.filePresenters || []), ...newFilePresenters];
    this.errors = [...(this.errors || []), ...newErrors, ...FilePresenter.errorsFrom(this.filePresenters)];
    return this;
  }

  // The EventPresenter (and its FilePresenters) should be serialized as late as possible
  // in the event lifecyle for accurate tracking of time elapsed since uploadAt.
  serialize() {
    // `.serialize()` will also serialize the instance's FilePresenters
    const serializedFiles = this.filePresenters.map((_fp) => _fp.serialize());

    return {
      version: KJ_UPLOADER_VERSION,

      files: serializedFiles,
      isSuccessful: serializedFiles.length ? serializedFiles.every((_file) => _file.isSuccessful) : null,
      hasFailedFiles: serializedFiles.length ? serializedFiles.some((_file) => _file.isFailed) : null,

      hasErrors: this.errors.length > 0,
      errors: this.errors,
    };
  }
}

export default EventPresenter;
